import React, { useEffect, useState, useMemo } from "react";
import { Button, Checkbox, Divider, Form, Skeleton, message, Row, Col, ColorPicker } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectWithSearch } from "@comps/components"
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { getReleatedDataReq, updateDataReq } from "../requests";
import { Commons, Const } from "../../../constants";
import { createSelectList } from '@comps/commonFunctions';
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { getLeaveTypeTooltip } from "../../../common/leaveTooltips";
import LeavePolicyReview from "./LeavePolicyReview";
import { buildLeavePolicySummary, buildLeaveTypePayload } from "./leavePolicyReview";
import { makeFieldLabel } from "@utils/fieldTooltips";
const langKey = Const["leaveType"].lngKey
const formName = "createLeaveType";

const UpdateLeaveType = (props) => {
  const [saving, setsaving] = useState(false)
  const [loading, setloading] = useState(true)
  const [, setLoader] = useState(false);
  const [, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [genders, setGenders] = useState([])
  const [tenures, setTenures] = useState([])
  const [isComposite, setIscomposite] = useState(false)
  const [isShortLeave, setIsShort] = useState(false)
  const [isSplitable, setSplitable] = useState(false)
  const [isBackDate, setIsBackDate] = useState(false)
  const [isAttach, setIsAttach] = useState(false)
  const [isEncashment, setEncashment] = useState(false)
  const [isCarryForward, setCarryForward] = useState(false)
  const [limitTenureWithin, setLimitTenureWithin] = useState(false)
  const [allLeaveTypes, setAllLeaveTypes] = useState([])
  const [form] = Form.useForm();
  const [deletedCompositeLeaves] = useState([])
  const [deletedShortLeaves] = useState([])
  const [compositeLeaveTypes, setCompositeLeaveTypes] = useState([])
  const [shortLeaveTypes, setShortLeaveTypes] = useState([])
  const [fromDoj, setFromDoj] = useState(false);
  const [taxStructures, setTaxStructures] = useState([]);
  const [fontcolorHex, setFontColorHex] = useState('');
  const [reviewData, setReviewData] = useState(null);
  const fontColorHexString = useMemo(
    () => (
      typeof fontcolorHex === 'string' ? fontcolorHex : fontcolorHex.toHexString()),
    [fontcolorHex],
  );
  const [formatHex, setFormatHex] = useState('hex');

  useEffect(() => {
    getRemoteData();
    setFormData()
    // eslint-disable-next-line
  }, []);
  const getRemoteData = () => {
    makeRequestStateless(getReleatedDataReq, false, onGetRelated, false)
  }
  const onGetRelated = (response) => {

    setGenders(createSelectList([...response.genders, { id: 0, name: 'All' }]))
    setTenures(createSelectList(response.tenures))
    setTaxStructures(createSelectList(response.tax_structures))
    setAllLeaveTypes(createSelectList(response.all_leave_types))
    setloading(false)
  }
  const setFormData = () => {

    if (!props) {
      return
    }
    setCompositeLeaveTypes(props.record.composite_leave_types)
    setShortLeaveTypes(props.record.short_leave_type_slabs)

    setIsShort(props.record.is_short)
    setIscomposite(props.record.is_composite)
    setSplitable(props.record.splitable)
    setIsAttach(props.record.is_attachment_required)
    setEncashment(props.record.encashment)
    setCarryForward(props.record.carry_forward)
    setIsBackDate(props.record.is_back_date_allowed)
    setFromDoj(props.record.is_from_doj)
    setFontColorHex(props.record.font_color || '')
    form.setFieldsValue(props.record)
    if (props.record.pre_condition) {
      form.setFieldsValue(
        {
          gender_id: props.record.pre_condition.gender_id ? props.record.pre_condition.gender_id : 0,
          can_apply_in_probation: props.record.pre_condition.can_apply_in_probation,
          min_employee_experience: props.record.pre_condition.min_employee_experience,
          max_applications_in_employment: props.record.pre_condition.max_applications_in_employment,
          gap_between_applications: props.record.pre_condition.gap_between_applications,
          min_days_per_leave: props.record.pre_condition.min_days_per_leave,
          max_days_per_leave: props.record.pre_condition.max_days_per_leave,
          can_apply_for_remaining: props.record.pre_condition.can_apply_for_remaining,
          has_max_limit: props.record.pre_condition.has_max_limit,
          limit_tenure_id: props.record.pre_condition.limit_tenure_id,
          amount_apply_in_tenure: props.record.pre_condition.amount_apply_in_tenure,
        }
      )
    }
  }
  const onSubmit = (data) => {
    const payload = buildLeaveTypePayload(data, {
      fontColor: fontColorHexString,
      recordId: props.record.id,
      includeRowState: true,
      deletedCompositeLeaves,
      deletedShortLeaves,
    });
    const summary = buildLeavePolicySummary(payload, { genders, tenures, taxStructures, allLeaveTypes });
    setReviewData({ payload, summary });
  }

  const onViewSummary = () => {
    const data = form.getFieldsValue(true);
    const payload = buildLeaveTypePayload(data, {
      fontColor: fontColorHexString,
      recordId: props.record.id,
      includeRowState: false,
    });
    const summary = buildLeavePolicySummary(payload, { genders, tenures, taxStructures, allLeaveTypes });
    setReviewData({ payload, summary, readOnly: true });
  }

  const onConfirmSave = () => {
    if (!reviewData?.payload) {
      form.submit();
      return;
    }

    makeRequest(setLoader, updateDataReq, reviewData.payload, onSuccess, onError);
    setsaving(true)
  }

  const onSuccess = (data, res) => {
    setSaveLoader(true)
    message.success("Record Updated");
    props.onCompleted(data.leave_types.data);
  }

  const onError = (err, res) => {
    setsaving(false)
    setReviewData(null);
    setErrors(res?.response?.data?.errors || []);
    message.error(res?.response?.data?.message || "Unable to update leave policy");
  }

  //set deleted rows

  //set deleted breaks
  const onDeleteClt = (key, state) => {
    if (compositeLeaveTypes[key] !== undefined && compositeLeaveTypes[key].id !== undefined && state === 'Deleted') {
      compositeLeaveTypes[key].row_state = 'Deleted'
      deletedCompositeLeaves.push(compositeLeaveTypes[key])
    }
  }
  const onDeleteSls = (key, state) => {
    if (shortLeaveTypes[key] !== undefined && shortLeaveTypes[key].id !== undefined && state === 'Deleted') {
      shortLeaveTypes[key].row_state = 'Deleted'
      deletedShortLeaves.push(shortLeaveTypes[key])
    }
  }
  //
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    !props.disabled &&
    (
      reviewData
        ? <Button key="back_button" onClick={ () => setReviewData(null) }>Back to edit</Button>
        : <SaveButton loading={ saving } form={ formName } key="review_button" htmlType="submit" text="Review changes" />
    ),
    props.disabled && reviewData &&
    <Button key="back_view_button" onClick={ () => setReviewData(null) }>Back to details</Button>,
    !reviewData &&
    <Button key="summary_button" onClick={ onViewSummary }>View summary</Button>,
    !props.disabled && reviewData && !reviewData.readOnly &&
    <SaveButton loading={ saving } key="create_button" onClick={ onConfirmSave } text="Save changes" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1300 } maskClosable={ false }
      mainTitle={ trans(Commons[props.disabled ? 'view' : 'update']) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) } >
      <Skeleton loading={ loading }>
        { reviewData && <LeavePolicyReview summary={ reviewData.summary } /> }
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } disabled={ props.disabled } scrollToFirstError style={ { display: reviewData ? "none" : "block" } }>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="name" rules={ rules.name } label={ fieldLabel("name", trans(Commons.name)) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.name`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="short_name" rules={ rules.short_name } label={ fieldLabel("short_name") }
                className="da-mb-16"
                { ...getErrorProps(errors['short_name']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.short_name`) } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="font_color" rules={ rules.font_color } label={ fieldLabel("font_color") }
                className="da-mb-16"
                { ...getErrorProps(errors['font_color']) } size="small"
              >
                <ColorPicker
                  format={ formatHex }
                  value={ fontcolorHex }
                  onChange={ setFontColorHex }
                  onFormatChange={ setFormatHex } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_active" rules={ rules.is_active } label={ fieldLabel("is_active") }
                className="da-mb-16"
                { ...getErrorProps(errors['is_active']) } size="small"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_auto_allotment" rules={ rules.is_auto_allotment } label={ fieldLabel("is_auto_allotment") }
                className="da-mb-16"
                { ...getErrorProps(errors['is_auto_allotment']) } size="small"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_from_doj" rules={ rules.balance_on_joining } label={ fieldLabel("balance_on_joining") }
                className="da-mb-16"
                { ...getErrorProps(errors['balance_on_joining']) } size="small"
                valuePropName="checked"
              >
                <Checkbox onChange={ (e) => setFromDoj(e.target.checked) } />
              </Form.Item>
            </Col>
            {
              !fromDoj && <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="tax_structure_id" rules={ rules.tax_structure_id } label={ fieldLabel("tax_structure_id") }
                  className="da-mb-16"
                  size="small"

                >
                  <SelectWithSearch options={ taxStructures } placeholder={ trans(`${langKey}.tax_structure_id`) } />
                </Form.Item>
              </Col>
            }

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_composite" rules={ rules.is_composite } label={ fieldLabel("is_composite") }
                className="da-mb-16"
                { ...getErrorProps(errors['is_composite']) } size="small"
                valuePropName="checked"
              >
                <Checkbox onChange={ (e) => setIscomposite(e.target.checked) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_short" rules={ rules.is_short } label={ fieldLabel("is_short") }
                className="da-mb-16"
                { ...getErrorProps(errors['is_short']) } size="small"
                valuePropName="checked"
              >
                <Checkbox onChange={ (e) => setIsShort(e.target.checked) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_deductible" rules={ rules.is_deductible } label={ fieldLabel("is_deductible") }
                className="da-mb-16"
                { ...getErrorProps(errors['is_deductible']) } size="small"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="sandwich" rules={ rules.sandwich } label={ fieldLabel("sandwich") }
                className="da-mb-16"
                { ...getErrorProps(errors['sandwich']) } size="small"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="splitable" rules={ rules.splitable } label={ fieldLabel("splitable") }
                className="da-mb-16"
                { ...getErrorProps(errors['splitable']) } size="small"
                valuePropName="checked"
              >
                <Checkbox onChange={ (e) => setSplitable(e.target.checked) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="prorated" rules={ rules.prorated } label={ fieldLabel("prorated") }
                className="da-mb-16"
                { ...getErrorProps(errors['prorated']) } size="small"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="add_earned_quota" rules={ rules.add_earned_quota } label={ fieldLabel("add_earned_quota") }
                className="da-mb-16"
                { ...getErrorProps(errors['add_earned_quota']) } size="small"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_back_date_allowed" rules={ rules.is_back_date_allowed } label={ fieldLabel("is_back_date_allowed") }
                className="da-mb-16"
                { ...getErrorProps(errors['is_back_date_allowed']) } size="small"
                valuePropName="checked"
              >
                <Checkbox onChange={ (e) => setIsBackDate(e.target.checked) } />
              </Form.Item>
            </Col>
            {
              isBackDate ?
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="days_back_date_allowed" rules={ rules.days_back_date_allowed } label={ fieldLabel("days_back_date_allowed") }
                    className="da-mb-16"
                    { ...getErrorProps(errors['days_back_date_allowed']) } size="small"
                  >
                    <InputText placeholder={ trans(`${langKey}.days_back_date_allowed`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>
                : ''
            }

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_attachment_required" rules={ rules.is_attachment_required } label={ fieldLabel("is_attachment_required") }
                className="da-mb-16"
                { ...getErrorProps(errors['is_attachment_required']) } size="small"
                valuePropName="checked"
              >
                <Checkbox onChange={ (e) => setIsAttach(e.target.checked) } />
              </Form.Item>
            </Col>
            {
              isAttach ?
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="days_attachment_required" rules={ rules.days_attachment_required } label={ fieldLabel("days_attachment_required") }
                    className="da-mb-16"
                    { ...getErrorProps(errors['days_attachment_required']) } size="small"
                    valuePropName="checked"
                  >
                    <InputText placeholder={ trans(`${langKey}.days_attachment_required`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>
                : ''
            }

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="encashment" rules={ rules.encashment } label={ fieldLabel("encashment") }
                className="da-mb-16"
                { ...getErrorProps(errors['encashment']) } size="small"
                valuePropName="checked"
              >
                <Checkbox onChange={ (e) => setEncashment(e.target.checked) } />
              </Form.Item>
            </Col>

            {
              isEncashment ?
                <>
                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="encashment_min" rules={ rules.encashment_min } label={ fieldLabel("encashment_min") }
                      className="da-mb-16"
                      { ...getErrorProps(errors['encashment_min']) } size="small"
                    >
                      <InputText placeholder={ trans(`${langKey}.encashment_min`) } type="number" onWheel={ (e) => e.target.blur() } />
                    </Form.Item>
                  </Col>

                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="encashment_max" rules={ rules.encashment_max } label={ fieldLabel("encashment_max") }
                      className="da-mb-16"
                      { ...getErrorProps(errors['encashment_max']) } size="small"
                    >
                      <InputText placeholder={ trans(`${langKey}.encashment_max`) } type="number" onWheel={ (e) => e.target.blur() } />
                    </Form.Item>
                  </Col>
                </>
                : ''
            }

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="carry_forward" rules={ rules.carry_forward } label={ fieldLabel("carry_forward") }
                className="da-mb-16"
                { ...getErrorProps(errors['carry_forward']) } size="small"
                valuePropName="checked"
              >
                <Checkbox onChange={ (e) => setCarryForward(e.target.checked) } />
              </Form.Item>
            </Col>
            { isCarryForward ?
              <>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="carry_forward_min" rules={ rules.carry_forward_min } label={ fieldLabel("carry_forward_min") }
                    className="da-mb-16"
                    { ...getErrorProps(errors['carry_forward_min']) } size="small"
                  >
                    <InputText placeholder={ trans(`${langKey}.carry_forward_min`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="carry_forward_max" rules={ rules.carry_forward_max } label={ fieldLabel("carry_forward_max") }
                    className="da-mb-16"
                    { ...getErrorProps(errors['carry_forward_max']) } size="small"
                  >
                    <InputText placeholder={ trans(`${langKey}.carry_forward_max`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="carry_forward_years" rules={ rules.carry_forward_years } label={ fieldLabel("carry_forward_years") }
                    className="da-mb-16"
                    { ...getErrorProps(errors['carry_forward_years']) } size="small"
                  >
                    <InputText placeholder={ trans(`${langKey}.carry_forward_years`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>

              </>
              : '' }
            {/* <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="max_applications_in_month" rules={ rules.max_applications_in_month } label={ fieldLabel("max_applications_in_month", trans(`${langKey}.max_applications_in_month`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['max_applications_in_month']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.max_applications_in_month`) } type="number" onWheel={ (e) => e.target.blur() } />
              </Form.Item>
            </Col> */}
          </Row>

          <Divider>Pre Conditions</Divider>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="gender_id" rules={ rules.gender_id } label={ fieldLabel("gender_id") }
                className="da-mb-16"
                { ...getErrorProps(errors['gender_id']) } size="small"
              >
                <SelectWithSearch
                  defaultValue={ 0 }
                  placeholder={ trans(`${langKey}.gender_id`) }
                  options={ genders }
                />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="can_apply_in_probation" rules={ rules.can_apply_in_probation } label={ fieldLabel("can_apply_in_probation") }
                className="da-mb-16"
                { ...getErrorProps(errors['can_apply_in_probation']) } size="small"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="min_employee_experience" rules={ rules.min_employee_experience } label={ fieldLabel("min_employee_experience") }
                className="da-mb-16"
                { ...getErrorProps(errors['min_employee_experience']) } size="small"
              >
                <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.min_employee_experience`) } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="max_applications_in_employment" rules={ rules.max_applications_in_employment } label={ fieldLabel("max_applications_in_employment") }
                className="da-mb-16"
                { ...getErrorProps(errors['max_applications_in_employment']) } size="small"
              >
                <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.max_applications_in_employment`) } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="gap_between_applications" rules={ rules.gap_between_applications } label={ fieldLabel("gap_between_applications") }
                className="da-mb-16"
                { ...getErrorProps(errors['gap_between_applications']) } size="small"
              >
                <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.gap_between_applications`) } />
              </Form.Item>
            </Col>
          </Row>

          <Divider>Balance Settings</Divider>

          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="tenure_id" rules={ rules.tenure_id } label={ fieldLabel("tenure_id") }
                className="da-mb-16"
                { ...getErrorProps(errors['tenure_id']) } size="small"
              >
                <SelectWithSearch
                  placeholder={ trans(`${langKey}.tenure_id`) }
                  options={ tenures }
                />
              </Form.Item>
            </Col>

            { !isComposite ?
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="acc_count" rules={ rules.acc_count } label={ fieldLabel("acc_count") }
                  className="da-mb-16"
                  { ...getErrorProps(errors['acc_count']) } size="small"
                >
                  <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.acc_count`) } />
                </Form.Item>
              </Col>
              : '' }


            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="has_max_limit" rules={ rules.has_max_limit } label={ fieldLabel("has_max_limit") }
                className="da-mb-16"
                { ...getErrorProps(errors['has_max_limit']) } size="small"
                valuePropName="checked"
              >
                <Checkbox onChange={ (e) => setLimitTenureWithin(e.target.checked) } />
              </Form.Item>
            </Col>
            { limitTenureWithin ?
              <>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="limit_tenure_id" rules={ rules.limit_tenure_id } label={ fieldLabel("limit_tenure_id") }
                    className="da-mb-16"
                    { ...getErrorProps(errors['limit_tenure_id']) } size="small"
                  >
                    <SelectWithSearch
                      placeholder={ trans(`${langKey}.limit_tenure_id`) }
                      options={ tenures }
                    />
                  </Form.Item>
                </Col>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="amount_apply_in_tenure" rules={ rules.amount_apply_in_tenure } label={ fieldLabel("amount_apply_in_tenure") }
                    className="da-mb-16"
                    { ...getErrorProps(errors['amount_apply_in_tenure']) } size="small"
                  >
                    <InputText placeholder={ trans(`${langKey}.amount_apply_in_tenure`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>
              </>
              : '' }

            { isSplitable ?
              <>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="min_days_per_leave" rules={ rules.min_days_per_leave } label={ fieldLabel("min_days_per_leave") }
                    className="da-mb-16"
                    { ...getErrorProps(errors['min_days_per_leave']) } size="small"
                  >
                    <InputText placeholder={ trans(`${langKey}.min_days_per_leave`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="max_days_per_leave" rules={ rules.max_days_per_leave } label={ fieldLabel("max_days_per_leave") }
                    className="da-mb-16"
                    { ...getErrorProps(errors['max_days_per_leave']) } size="small"
                  >
                    <InputText placeholder={ trans(`${langKey}.max_days_per_leave`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="can_apply_for_remaining" rules={ rules.can_apply_for_remaining } label={ fieldLabel("can_apply_for_remaining") }
                    className="da-mb-16"
                    { ...getErrorProps(errors['can_apply_for_remaining']) } size="small"
                    valuePropName="checked"
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>


              </>
              : '' }
          </Row>

          { isComposite ?
            <>
              <div className="formlist-container">
                <h5 className="formlist-title">Composite Leave Settings</h5>
                <Form.List name="composite_leave_types" >
                  { (fields, { add, remove }) => (
                    <>
                      <Button onClick={ () => {
                        add()
                        //setRows(fields.length, 'Added')
                      } } icon={ <PlusOutlined /> } type="primary" className="add-node-button">Add Item</Button>
                      <div className="table-container">
                        <table className="table">
                          {
                            fields.length !== 0 && <thead>
                              <tr>
                                <th style={ { paddingLeft: 20 } }>{ trans(`${langKey}.leave_type_id`) }</th>
                                <th>{ trans(Commons.actions) }</th>
                              </tr>
                            </thead>
                          }
                          <tbody>
                            { fields.map(({ key, name, ...restField }) => (
                              <>
                                <tr>
                                  <td style={ { minWidth: '200px', paddingLeft: 20 } }>
                                    <Form.Item
                                      { ...restField }
                                      name={ [name, 'leave_type_id'] }
                                      rules={ rules.leave_type_id }
                                    >
                                      <SelectWithSearch
                                        options={ allLeaveTypes }
                                        placeholder={ trans(`${langKey}.leave_type_id`) } />
                                    </Form.Item>
                                  </td>

                                  <td>
                                    <DeleteOutlined className="formlist-remove" onClick={ () => {
                                      onDeleteClt(name, 'Deleted')
                                      remove(name)
                                    } } />
                                  </td>
                                </tr>
                              </>
                            )) }
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) }
                </Form.List>
              </div>
            </>
            : '' }

          { isShortLeave ?
            <>
              <div className="formlist-container">
                <h5 className="formlist-title">Short Leave Slabs</h5>
                <Form.List name="short_leave_type_slabs" >
                  { (fields, { add, remove }) => (
                    <>
                      <Button onClick={ () => {
                        add()
                        //setRows(fields.length, 'Added')
                      } } icon={ <PlusOutlined /> } type="primary" className="add-node-button">Add Item</Button>
                      <div className="table-container">
                        <table className="table">
                          {
                            fields.length !== 0 && <thead>
                              <tr>
                                <th style={ { paddingLeft: 20 } }>{ fieldLabel("short_leave_slab_name", trans(`${langKey}.shortleavename`)) }</th>
                                <th>{ fieldLabel("short_leave_slab_quota", trans(`${langKey}.quota`)) }</th>
                                <th>{ fieldLabel("short_leave_slab_type", trans(`${langKey}.type`)) }</th>
                                <th>{ fieldLabel("short_leave_slab_value", trans(`${langKey}.value`)) }</th>
                                <th>{ trans(Commons.actions) }</th>
                              </tr>
                            </thead>
                          }
                          <tbody>
                            { fields.map(({ key, name, ...restField }) => (
                              <>
                                <tr>
                                  <td style={ { minWidth: '200px', paddingLeft: 20 } }>
                                    <Form.Item
                                      { ...restField }
                                      name={ [name, 'name'] }
                                      rules={ rules.name }
                                    >
                                      <InputText placeholder={ trans(`${langKey}.name`) } />
                                    </Form.Item>
                                  </td>
                                  <td style={ { minWidth: '200px' } }>
                                    <Form.Item
                                      { ...restField }
                                      name={ [name, 'quota'] }
                                      rules={ rules.quota }
                                    >
                                      <InputText placeholder={ trans(`${langKey}.Balance`) } type="number" onWheel={ (e) => e.target.blur() } />
                                    </Form.Item>
                                  </td>
                                  <td style={ { minWidth: '200px' } }>
                                    <Form.Item
                                      { ...restField }
                                      name={ [name, 'type'] }
                                      rules={ rules.type }
                                    >
                                      <SelectWithSearch
                                        options={ [
                                          {
                                            label: 'Percentage',
                                            value: 'percentage',
                                          },
                                          {
                                            label: 'Flat',
                                            value: 'flat',
                                          }
                                        ] }
                                        placeholder={ trans(`${langKey}.type`) } />
                                    </Form.Item>
                                  </td>

                                  <td style={ { minWidth: '200px' } }>
                                    <Form.Item
                                      { ...restField }
                                      name={ [name, 'value'] }
                                      rules={ rules.value }
                                    >
                                      <InputText placeholder={ trans(`${langKey}.value`) } type="number" onWheel={ (e) => e.target.blur() } />
                                    </Form.Item>
                                  </td>

                                  <td>
                                    <DeleteOutlined className="formlist-remove" onClick={ () => {
                                      onDeleteSls(name, 'Deleted')
                                      remove(name)
                                    } } />
                                  </td>
                                </tr>
                              </>
                            )) }
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) }
                </Form.List>
              </div>
            </>
            : '' }

        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default UpdateLeaveType

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.req`) },
  ],
  short_name: [
    { required: true, message: trans(`${langKey}.short_name.req`) },
  ],
  gender_id: [
    { required: true, message: trans(`${langKey}.gender_id.req`) },
  ],
  tenure_id: [
    { required: true, message: trans(`${langKey}.tenure_id.req`) },
  ],
  acc_count: [
    { required: true, message: trans(`${langKey}.acc_count.req`) },
  ],
  leave_type_id: [
    { required: true, message: trans(`${langKey}.leave_type_id.req`) },
  ],
  quota: [
    { required: true, message: trans(`${langKey}.quota.req`) },
  ],
  type: [
    { required: true, message: trans(`${langKey}.type.req`) },
  ],
  value: [
    { required: true, message: trans(`${langKey}.value.req`) },
  ],
  tax_structure_id: [
    { required: true, message: trans(`${langKey}.tax_structure_id.req`) },
  ],
  max_applications_in_month: [
    { required: true, message: trans(`${langKey}.max_applications_in_month.req`) },
  ],
  days_back_date_allowed: [
    { required: true, message: trans(`${langKey}.days_back_date_allowed.req`) },
  ],
  days_attachment_required: [
    { required: true, message: trans(`${langKey}.days_attachment_required.req`) },
  ],
  encashment_min: [
    { required: true, message: trans(`${langKey}.encashment_min.req`) },
  ],
  encashment_max: [
    { required: true, message: trans(`${langKey}.encashment_max.req`) },
  ],
  carry_forward_min: [
    { required: true, message: trans(`${langKey}.carry_forward_min.req`) },
  ],
  carry_forward_max: [
    { required: true, message: trans(`${langKey}.carry_forward_max.req`) },
  ],
  carry_forward_years: [
    { required: true, message: trans(`${langKey}.carry_forward_years.req`) },
  ],
  min_days_per_leave: [
    { required: true, message: trans(`${langKey}.min_days_per_leave.req`) },
  ],
  max_days_per_leave: [
    { required: true, message: trans(`${langKey}.max_days_per_leave.req`) },
  ],
  limit_tenure_id: [
    { required: true, message: trans(`${langKey}.limit_tenure_id.req`) },
  ],
  amount_apply_in_tenure: [
    { required: true, message: trans(`${langKey}.amount_apply_in_tenure.req`) },
  ],

};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}

const fieldLabel = makeFieldLabel(getLeaveTypeTooltip, { namespace: formName, label: (key) => trans(`${langKey}.${key}`) });
